export function shellAppToDisplayName(app) {
    return (app.displayName ||
        (app.vmid === 'authzn' ? 'Identity and Tenant Management' : app.name));
}
